import * as Views from "./views";

const Module = {
    name: "saltedgeaccounts",
    defaultRoutePath: "/legalentities/saltedgeaccount",
    menuItemScope: "legalentities",
    menuItemName: "saltedgeaccounts",
    routes: [
        {
            path: "/legalentities/saltedgeaccount",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        {
            path: "create",
            Component: Views.Create,
        },
        {
            path: "saltedgeTransactions",
            Component: Views.SaltedgeTransactions,
        },
    ],

}

export default Module;
